export class LanguageChangeAction {
  static readonly type = '[Language] LanguageChangeAction';
}
